import {
  Module,
  VuexModule,
  Action,
  Mutation,
} from 'vuex-module-decorators';

import {
  BASE_URL, GET_MECHANIC_GAME_REPORT,
  GET_PATTERN_LIST,
  M_POST, SET_PATTERN_MAINTENANCE,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'mechanic' })
export default class Mechanic extends VuexModule {
  mechanic: any = [];

  dataGame: any = [];

  @Mutation
  mutateMechanic(mechanic: any) {
    this.mechanic = mechanic;
  }

  @Action({ commit: 'mutateMechanic' })
  FetchPatternList() {
    return Vue.axios({
      url: BASE_URL + GET_PATTERN_LIST,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action({ commit: 'mutateMechanic' })
  PatternMaintenance(req) {
    return Vue.axios({
      url: BASE_URL + SET_PATTERN_MAINTENANCE,
      method: M_POST,
      data: req,
    }).then(({ data }) => {
      const { code, message } = data.status;
      if (code === 0) {
        return data.status;
      } else {
        throw message;
      }
    }).catch((err) => err);
  }

  @Action({ commit: 'mutateGameReport' })
  GetMechanicReport(mechanic: any) {
    return Vue.axios({
      url: BASE_URL + GET_MECHANIC_GAME_REPORT,
      method: M_POST,
      data: mechanic,
    }).then(({ data }) => {
      const { code, message } = data.status;
      if (code === 0) {
        return data.data;
      } else {
        throw message;
      }
    }).catch((err) => err);
  }

  @Mutation
  mutateGameReport(dataGame: any) {
    this.dataGame = dataGame;
  }
}
